import useCms from './cms/useCms'
import type {
  SbAdvantagePage,
  SbAdvantageProduct,
  StoryData,
} from '~/cms/storyblok/types/storyblok.d.ts'

interface AdvantagePageItem {
  slug: string
  products: {
    orderNumber: string
    orderNumbers: string[]
  }[]
}

export default (customOrderNumber?: string) => {
  const cms = useCms<SbAdvantagePage[]>('advantage-page')
  const router = useRouter()
  const { toLocalePath } = useRouteHelpers()
  const advantagePages = ref<AdvantagePageItem[]>([])

  const load = async () => {
    if (cms.data.value || cms.fetching.value) return
    customOrderNumber = customOrderNumber?.replace('-', '')?.trim()

    await cms.fetchByFolder('', {
      contentType: 'AdvantagePage',
      perPage: 100,
    })

    advantagePages.value = (cms.data.value as StoryData<SbAdvantagePage>[]).map(
      (page) => ({
        slug: page.full_slug,
        products:
          page.content?.advantage_products?.map((p: SbAdvantageProduct) => ({
            orderNumber: p.order_number?.replace('-', ''),
            orderNumbers: parseOrderNumbers(page),
          })) || [],
      }),
    ) as AdvantagePageItem[]
  }

  return {
    goToAdvantagePage: async (orderNumber?: string) => {
      if (!orderNumber) return false
      orderNumber = orderNumber.replace('-', '')
      await load()

      // Find the advantage page that contains the order number
      let targetAdvantagePage = advantagePages.value.find((page) =>
        page.products.some((p) => p.orderNumber === orderNumber),
      )

      // If not found, try to find the advantage page by specific order numbers
      if (!targetAdvantagePage) {
        targetAdvantagePage = advantagePages.value.find((page) =>
          page.products.some((p) => p.orderNumbers.includes(orderNumber!)),
        )
      }

      if (!targetAdvantagePage) return false

      let path = '/' + targetAdvantagePage.slug
      if (orderNumber) path += '?' + queryString(`on=${orderNumber}`)

      router.push(toLocalePath(path))
      return true
    },
  }
}

function parseOrderNumbers(adantagePage: StoryData<SbAdvantagePage>): string[] {
  return (
    (
      adantagePage?.content.advantage_products?.map(
        (p: SbAdvantageProduct) => p.order_numbers || '',
      ) || []
    )
      .join('\n')
      .replace(/[^\d\n]/g, '')
      .split('\n') || []
  ).filter(Boolean)
}
